import { COPILOT_FUNCTION_NAMES } from '@Sage/ssm-web5';
import Context from 'managers/Context';
import { translateObjectB2ToB4 } from 'utils/fm/fields';
import { getEntityFromString } from 'utils/getEntityFromString';

/**
 * Gets the current entity CRUD state from Redux store.
 *
 * @returns {Object} Object containing activeCrudName and entityCrud state
 */
const getEntityCrudState = () => {
    const state = Context.store.getState();
    const entityCrud = state.entityCrud;
    const activeCrudName = entityCrud.activeModal.length
        ? entityCrud.activeModal[entityCrud.activeModal.length - 1]
        : entityCrud.active;
    return { activeCrudName, entityCrud };
};

/**
 * Populates the form with current CRUD field data, translating from B2 to B4 format.
 * If no active CRUD exists or has no data, returns an empty form.
 */
export const getInitialFormFunction = {
    key: COPILOT_FUNCTION_NAMES.GET_INITIAL_FORM,
    definition: ({ entity }) => {
        const { activeCrudName, entityCrud } = getEntityCrudState();
        const freshCrudData = entityCrud[activeCrudName]?.data || {};
        const entityObject = getEntityFromString(entity);
        const form = translateObjectB2ToB4(entityObject, freshCrudData);

        return Promise.resolve({
            type: 'form',
            entity,
            form,
            completed: false,
        });
    },
};
